import handleFloatingRegistrationBtn from './handleFloatingRegisterBtn';

import {LoginForm} from './LoginForm';
import LoginPrompt from './LoginPrompt';

function loadFrontendScripts() {
    handleFloatingRegistrationBtn();
    initFEComponents();
}

/**
 * @param {AbortSignal} signal
 */
function addLoginButtonClickListener(signal) {
    const elLoginBtn = document.querySelector('.btn-signin');

    if(!elLoginBtn) return;

    elLoginBtn.addEventListener('click', function(e) {
        e.preventDefault();
        window.setLoginFormDisplay(true);
    }, { signal });

}

function initFEComponents() {
	const controller = new AbortController();
	const {signal} = controller;

    document.addEventListener('DOMContentLoaded', function() {
        document.components = {
            LoginForm: LoginForm
        }

        document.dispatchEvent(new Event('adwComponentsLoaded'));

        addLoginButtonClickListener();

        const elModalContainer = document.getElementById('modal-for-webinar');
        const elPage = document.getElementById('page');
		if(elPage) {
			const ReactDOM = window.ReactDOM;
			elPage.insertAdjacentElement( 'beforeend', elModalContainer );
			const root = ReactDOM.client.createRoot(elModalContainer);
            console.log( 'ReactDOM.client version: ', ReactDOM.client.version );
            console.log( 'React version: ', React.version );
			root.render(<LoginPrompt />);
		}
    }, { once: true, signal });

}

loadFrontendScripts();
